import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { ProductsTracker } from './trackers';
export const trackDeleteProduct = () => {
  CrmLogger.log('indexInteractions', {
    action: 'delete product'
  });
  ProductsTracker.track('productPanelUsage', {
    action: 'Delete product'
  });
};